import { ActionTree } from 'vuex'
import * as types from './mutationType'
import { RootState } from '../../types'
import { AuthState } from './types'
import firebaseHelper from '@/helper/firebaseHelper'
import * as api from '../../models/auth'

export const actions: ActionTree<AuthState, RootState> = {
  handler: () => {},
  test: () => {
    return true
  },
  // NOTE: Set Google User Data for Backend
  setGoogleUserAuth: ({ state, commit, rootState}: any, log: string) => {
    return api.setGsuiteAuth({
      uid: state.uid,
      email: state.email,
      accessToken: state.accessToken,
      refreshToken: state.refreshToken,
      locale: rootState.lang,
      log: log
    }).then((res) => {
      commit(types.SET_IS_ABEJA_ADMIN, res.isAbejaAdmin)
      return commit(types.SET_ROLE, res.role)
    }).catch((err) => {
      return Promise.reject(err)
    })
  },
  // NOTE: set Micrsoft User Data for Backend
  setMicrosoftUserAuth: ({ state, commit, rootState}: any, log: string) => {
    return api.setMicrosoftAuth({
      uid: state.uid,
      email: state.email,
      accessToken: state.accessToken,
      refreshToken: state.refreshToken,
      locale: rootState.lang,
      log: log
    }).then((res) => {
      commit(types.SET_IS_ABEJA_ADMIN, res.isAbejaAdmin)
      return commit(types.SET_ROLE, res.role)
    }).catch((err) => {
      return Promise.reject(err)
    })
  },
  // NOTE: set Google login data
  setLoginByGoogle: async ({ commit }: any, res: any) => {
    if (!res?.user || !res?.additionalUserInfo || !res?.credential) {
      return new Error('Invalid Data')
    }
    await commit(types.SET_IS_NEW_USER, res.additionalUserInfo.isNewUser)
    await commit(types.SET_ACCESS_TOKEN, res.credential.accessToken)
    await commit(types.SET_REFRESH_TOKEN, res.user.refreshToken)
    const obj = {
      uid: res.user.uid,
      name: res.additionalUserInfo.profile.name,
      email: res.additionalUserInfo.profile.email,
      picture: res.additionalUserInfo.profile.picture,
      signInMethod: res.credential.signInMethod,
    }
    return commit(types.SET_USER_DATA, obj)
  },
  // NOTE: set Microsoft login data
  setLoginByMicrosoft: async ({ commit }: any, res: any) => {
    if (!res?.user || !res?.additionalUserInfo || !res?.credential) {
      return new Error('Invalid Data')
    }
    await commit(types.SET_IS_NEW_USER, res.additionalUserInfo.isNewUser)
    await commit(types.SET_ACCESS_TOKEN, res.credential.accessToken)
    await commit(types.SET_REFRESH_TOKEN, res.user.refreshToken)
    const obj = {
      // uid: res.user.uid,
      uid: res.user.providerData[0].uid,
      name: res.additionalUserInfo.profile.displayName,
      email: res.additionalUserInfo.profile.mail,
      picture: '',
      signInMethod: res.credential.signInMethod,
    }
    return commit(types.SET_USER_DATA, obj)
  },
  getMicrosoftUserInfo: async ({state}: any) => {
    const result = await api.getMicrosoftUserInfo({
      accessToken: state.accessToken
    })
    console.log('getMicrosoftUserInfo', result)
  },
  // NOTE: set current Access Token
  setCurrentToken: async ({ commit }: any) => {
    return firebaseHelper.getCurrentToken().then((res) => {
      return commit(types.SET_ACCESS_TOKEN, res)
    })
  },
  // NOTE: set current User data
  setCurrentData: async ({ commit }: any) => {
    return await firebaseHelper.getCurrentUser().then( async (res: any) => {
      // console.log('actions res', res)
      if (!res) return Promise.reject(false)
      await commit(types.SET_REFRESH_TOKEN, res?.refreshToken || '')
      return commit(types.SET_USER_DATA, res)
    }).then(() => {
      return firebaseHelper.getCurrentToken()
    }).then((token) => {
      return commit(types.SET_ACCESS_TOKEN, token)
    }).catch(() => {
      return Promise.reject(false)
    })
  },
  // NOTE: set Current User's info from API
  setApiUserAuth: async ({ commit, state }: any) => {
    return api.getUserAuth(state.uid).then((res) => {
      commit(types.SET_ROLE, res.role)
      commit(types.SET_IS_ABEJA_ADMIN, res.isAbejaAdmin)
      commit(types.SET_CUSTOMER_NAME, res.customerName)
      return true
    }).catch((err) => {
      // NOTE: API FIRST USER
      if (err.response?.status === '401') {
        commit(types.SET_IS_NEW_USER, true)
      }
      return Promise.reject(false)
    })
  },
  // NOTE: logout and clear login data
  signOut: async ({ dispatch, commit, state }: any) => {
    dispatch('setLoadingState', 'logout', { root: true })
    return firebaseHelper.signOut().then(() => {
      const loginType = state.signInMethod
      if (loginType.includes('google')) {
        return commit(types.LOGOUT_GOOGLE)
      } else {
        return commit(types.LOGOUT_MICROSOFT)
      }
    }).catch((err) => {
      return Promise.reject(err)
    }).finally(() => {
      return dispatch('unsetLoadingState', 'logout', { root: true })
    })
  },
  // NOTE: Customer data
  loadCustomerSetting: async ({ commit }: any, uid: string) => {
    return api.getCustomerSetting(uid).then((res) => {
      commit(types.SET_CUSTOMER_NAME, res.name)
      commit(types.SET_CUSTOMER_SETTING, {
        customerId: res.customerId,
        country: res.country,
        externalServiceId: res.externalServiceId,
        phone: res.phone,
        postCode: res.postCode,
        purchaseType: res.purchaseType,
        representativeUserName: res.representativeUserName,
        address: res.address
      })
    })
  },
  saveCustomerSetting: ( _: any, { uid, data }: any) => {
    return api.updateCustomerSetting(uid, data)
  },
  loadLicenseList: ( { commit }: any, uid: string) => {
    return api.loadLicenseList(uid).then((res) => {
      commit(types.SET_LICENSE_LIST, res)
    })
  },
  loadAdminLicenseData: ( { commit }: any, uid: string) => {
    return api.loadAdminLicenseList(uid).then((res) => {
      commit(types.SET_LICENSE_LIST, res)
    })
  },
  initAdminCustomerSetting: ( { commit }: any) => {
    commit(types.SET_SELECTED_CUSTOMER, {
      name: '',
      customerId: '',
      country: '',
      externalServiceId: '',
      phone: '',
      postCode: '',
      purchaseType: '',
      representativeUserName: '',
      address: ''
    })
  },
  loadAdminSelectedCustomer: ( { commit }: any, { uid, name }: any) => {
    return api.loadAdminSelectedCustomer(uid, name).then((res) => {
      commit(types.SET_SELECTED_CUSTOMER, res)
    })
  },
  updateAdminCustomerSetting: ( _: any, { uid, data }: any) => {
    return api.updateAdminCustomerSetting(uid, data)
  },
  savePurchasedLicense: ( _: any, { uid, cardToken, licenseType, count }: any) => {
    return api.savePurchasedLicense(uid, cardToken, licenseType, count)
  },
  saveAdminPurchasedLicense: ( _: any, { uid, data }: any) => {
    return api.saveAdminPurchasedLicense(uid, data)
  }
}

export default actions
